import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import {useTranslation} from "react-i18next"
import SelectLexiconsBtn from "../../components/select-lexicons-btn/SelectLexiconsBtn"
import SkipLexiconBtn from "../../components/skip-lexicon-btn/SkipLexiconBtn"
import lexiconNavIcon from "../../assets/icon/lexicons-nav.svg"
import useTeamLexiconId from "../../swrCustomHooks/useTeamLexiconId"
import useTeamLexiconitems from "../../swrCustomHooks/useTeamLexiconitems"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import LexiconAccordion from "../../components/lexicon-accordion/LexiconAccordion"
import {toast} from "react-toastify"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function StWorkflowLexicons01({project, setIsPulling}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {teamLexiconId, isLoadingTeamLexiconId, isErrorTeamLexiconId} = useTeamLexiconId(sessionContext.idTeam)
    const {teamLexiconItems, isLoadingTeamLexiconItems, isErrorTeamLexiconItems} = useTeamLexiconitems(teamLexiconId)

    const skipLexiconsStep = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            const bodyRequest = {
                lexicon_status: "skip"
            }
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            axios.put(`${API_PROJECTS}/${project.id}`, bodyRequest, headersRequest)
            .then(() => {
                axios.post(`${API_PROJECTS}/${project.id}/tries`, {step: "transcription"}, headersRequest)
                .then((response) => {
                    if (response.data.message === `maximun number of tries for "transcription" has been reached or exceeded`) {
                        toast.warning(t("The maximum number of transcriptions has been reached or exceeded!"))
                    }
                    setIsPulling(true)
                    })
                    .catch((error) => {
                        console.error("POST /projects/project/tries: ", error)
                    })
                })
                .catch((error) => {
                    console.error("PUT /projects/project: ", error)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (isErrorTeamLexiconId || isErrorTeamLexiconItems ||
        isLoadingTeamLexiconId || isLoadingTeamLexiconItems ||
        teamLexiconItems.message || teamLexiconId.message) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION ST-WORKFLOW-LEXICON-01">
            <div className="workflow-lexicon-header">
                <LexiconAccordion lexiconName={t("Team Lexicon")} lexiconItems={teamLexiconItems} lexiconID={teamLexiconId} isDisable={true}/>
            </div>
            {!project.finished &&
                <div className="workflow-lexicon-content">
                    <div className="visual">
                        <img src={lexiconNavIcon} alt=""/>
                    </div>
                    <h2>{t("CHOICE OF LEXICONS")}</h2>
                    <p>{t("Select an additionnal lexicon for your project (optional).")}</p>
                    <div className="actions">
                        <SelectLexiconsBtn/>
                        <SkipLexiconBtn skipLexiconsStep={skipLexiconsStep}/>
                    </div>
                </div>
            }
        </div>
        </>
    )
}